import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EPageTitle } from '../../shared/enums/page-title.enum';
import { DataSetSettingEnum } from '../../shared/enums/data-set-setting.enum';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
    dataSetSetting = DataSetSettingEnum;
    constructor(private _translate: TranslateService) { }

    translateTitle(titleId: number, selectedTabIndex?: number, selectedDataSet?: number): string {
        let title = '';
        switch (titleId) {
            case EPageTitle.PROJECT_CHARACTERISTICS:
                title = this._translate.instant('HEADER.PROJECT_CHARACTERISTICS');
                break;
            case EPageTitle.BUILDING_CHARACTERISTICS:
                title = this._translate.instant('HEADER.BUILDING_CHARACTERISTICS');
                break;
            case EPageTitle.COMPONENTS:
                title = this._translate.instant('HEADER.COMPONENTS');
                break;
            case EPageTitle.INDICATORS:
                title = this._translate.instant('INDICATORS.TITLE');
                break;
            case EPageTitle.RESULTS:
                // Check if selectedTabIndex is null
                if (selectedTabIndex === null || selectedTabIndex === undefined) {
                    title = this._translate.instant('HEADER.RESULTS'); // Static title when selectedTabIndex is null
                } else {
                    // Use dynamic title logic based on selectedTabIndex and selectedDataSet
                    if (selectedTabIndex == 0) {
                        title = (selectedDataSet == this.dataSetSetting.A1A2 ? this._translate.instant('HEADER.RESULTSA1ANDA2')
                            : selectedDataSet == this.dataSetSetting.A2 ? this._translate.instant('HEADER.RESULTSA2')
                                : this._translate.instant('HEADER.RESULTSA1'));
                    }
                    else {
                        title = (selectedDataSet == this.dataSetSetting.A1A2 || selectedDataSet == this.dataSetSetting.A2)
                                    ? this._translate.instant('HEADER.EXTRA_INDICATOR_RESULTSA2')
                                    : this._translate.instant('HEADER.EXTRA_INDICATOR_RESULTSA1');
                    }
                }
                break;
        }
        return title;
    }
}
